/**
 * On-Call Schedules API Services
 */

import datacentral from '@/utils/axios/datacentral'
import { ErrorResponse, ResponseArray, ResponseObject } from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'

import { OncallScheduleResponse } from '../types/response'
import { CreateSchedulePayload, UpdateSchedulePayload } from '../types/payload'

export const getOncallSchedules = async (
    payload: DataGridPayload & { department_id?: number; is_active?: boolean }
) => {
    const params = new URLSearchParams({
        page: String(payload?.page || 1),
        page_size: String(payload?.page_size || 10),
    })
    if (payload?.q) params.append('q', payload.q)
    if (payload?.filters) params.append('filters', payload.filters)
    if (payload?.department_id)
        params.append('department_id', String(payload.department_id))
    if (payload?.is_active !== undefined)
        params.append('is_active', String(payload.is_active))

    const response = await datacentral.get<
        ResponseArray<OncallScheduleResponse>
    >(`/oncall/schedules?${params.toString()}`)

    // Transform result to results for GokuDataGrid compatibility
    const data = response.data as any
    if (data.result && !data.results) {
        data.results = data.result
    }
    return data
}

export const getOncallScheduleByID = async (
    id: number
): Promise<ResponseObject<OncallScheduleResponse>> => {
    const response = await datacentral.get<
        ResponseObject<OncallScheduleResponse>
    >(`/oncall/schedules/${id}`)
    return response.data
}

export const createOncallSchedule = async (
    payload: CreateSchedulePayload
): Promise<ResponseObject<OncallScheduleResponse> | ErrorResponse> => {
    const response = await datacentral.post('/oncall/schedules', payload)
    return response.data
}

export const updateOncallSchedule = async (payload: {
    id: number
    data: UpdateSchedulePayload
}): Promise<ResponseObject<OncallScheduleResponse> | ErrorResponse> => {
    const response = await datacentral.put(
        `/oncall/schedules/${payload.id}`,
        payload.data
    )
    return response.data
}

export const deleteOncallSchedule = async (
    id: number
): Promise<ResponseObject<null> | ErrorResponse> => {
    const response = await datacentral.delete(`/oncall/schedules/${id}`)
    return response.data
}

export const exportFinalOncallSchedule = async (
    id: number,
    startDate: string,
    endDate: string
) => {
    const params = new URLSearchParams({
        start_date: startDate,
        end_date: endDate,
    })
    const response = await datacentral.get(
        `/oncall/schedules/${id}/export-final?${params.toString()}`,
        { responseType: 'blob' }
    )
    return response.data
}

// ============================================================
// DEPRECATED: Schedule Members - use rotation members instead
// These endpoints have been removed from the backend
// Use rotation member services from ./rotations.ts instead
// ============================================================
